// Uitgooi-hulp: vaste routes voor dubbel uit met 3 darts, en een rekenmodel voor de rest
// (minder darts over, master- en enkel-uit, en klaarzetten als uitgooien deze beurt niet kan).

// Gangbare routes voor dubbel uit met 3 darts (zoals profs ze gooien).
export const CHECKOUT_MAP: Record<number, string[]> = {
  170: ['T20', 'T20', 'Bull'],
  167: ['T20', 'T19', 'Bull'],
  164: ['T20', 'T18', 'Bull'],
  161: ['T20', 'T17', 'Bull'],
  160: ['T20', 'T20', 'D20'],
  158: ['T20', 'T20', 'D19'],
  157: ['T20', 'T19', 'D20'],
  156: ['T20', 'T20', 'D18'],
  155: ['T20', 'T19', 'D19'],
  154: ['T20', 'T18', 'D20'],
  153: ['T20', 'T19', 'D18'],
  152: ['T20', 'T20', 'D16'],
  151: ['T20', 'T17', 'D20'],
  150: ['T20', 'T18', 'D18'],
  149: ['T20', 'T19', 'D16'],
  148: ['T20', 'T16', 'D20'],
  147: ['T20', 'T17', 'D18'],
  146: ['T20', 'T18', 'D16'],
  145: ['T20', 'T15', 'D20'],
  144: ['T20', 'T20', 'D12'],
  143: ['T20', 'T17', 'D16'],
  142: ['T20', 'T14', 'D20'],
  141: ['T20', 'T15', 'D18'],
  140: ['T20', 'T16', 'D16'],
  139: ['T20', 'T13', 'D20'],
  138: ['T20', 'T18', 'D12'],
  137: ['T19', 'T16', 'D16'],
  136: ['T20', 'T20', 'D8'],
  135: ['T20', 'T17', 'D12'],
  134: ['T20', 'T14', 'D16'],
  133: ['T20', 'T19', 'D8'],
  132: ['T20', 'T16', 'D12'],
  131: ['T20', 'T13', 'D16'],
  130: ['T20', 'T18', 'D8'],
  129: ['T19', 'T16', 'D12'],
  128: ['T18', 'T14', 'D16'],
  127: ['T20', 'T17', 'D8'],
  126: ['T19', 'T19', 'D6'],
  125: ['25', 'T20', 'D20'],
  124: ['T20', 'T16', 'D8'],
  123: ['T19', 'T16', 'D9'],
  122: ['T18', 'T18', 'D7'],
  121: ['T20', 'T11', 'D14'],
  120: ['T20', '20', 'D20'],
  119: ['T19', '12', 'Bull'],
  118: ['T20', '18', 'D20'],
  117: ['T20', '17', 'D20'],
  116: ['T20', '16', 'D20'],
  115: ['T20', '15', 'D20'],
  114: ['T20', '14', 'D20'],
  113: ['T19', '16', 'D20'],
  112: ['T20', '12', 'D20'],
  111: ['T20', '19', 'D16'],
  110: ['T20', '10', 'D20'],
  109: ['T20', '9', 'D20'],
  108: ['T20', '16', 'D16'],
  107: ['T19', '10', 'D20'],
  106: ['T20', '10', 'D18'],
  105: ['T20', '13', 'D16'],
  104: ['T20', '12', 'D16'],
  103: ['T20', '3', 'D20'],
  102: ['T20', '10', 'D16'],
  101: ['T17', '10', 'D20'],
  100: ['T20', 'D20'],
  99: ['T19', '10', 'D16'],
  98: ['T20', 'D19'],
  97: ['T19', 'D20'],
  96: ['T20', 'D18'],
  95: ['T19', 'D19'],
  94: ['T18', 'D20'],
  93: ['T19', 'D18'],
  92: ['T20', 'D16'],
  91: ['T17', 'D20'],
  90: ['T20', 'D15'],
  89: ['T19', 'D16'],
  88: ['T16', 'D20'],
  87: ['T17', 'D18'],
  86: ['T18', 'D16'],
  85: ['T15', 'D20'],
  84: ['T20', 'D12'],
  83: ['T17', 'D16'],
  82: ['T14', 'D20'],
  81: ['T19', 'D12'],
  80: ['T20', 'D10'],
  79: ['T13', 'D20'],
  78: ['T18', 'D12'],
  77: ['T15', 'D16'],
  76: ['T20', 'D8'],
  75: ['T17', 'D12'],
  74: ['T14', 'D16'],
  73: ['T19', 'D8'],
  72: ['T16', 'D12'],
  71: ['T13', 'D16'],
  70: ['T18', 'D8'],
  69: ['T15', 'D12'],
  68: ['T20', 'D4'],
  67: ['T17', 'D8'],
  66: ['T10', 'D18'],
  65: ['T11', 'D16'],
  64: ['T16', 'D8'],
  63: ['T13', 'D12'],
  62: ['T10', 'D16'],
  61: ['T15', 'D8'],
  60: ['20', 'D20'],
  59: ['19', 'D20'],
  58: ['18', 'D20'],
  57: ['17', 'D20'],
  56: ['16', 'D20'],
  55: ['15', 'D20'],
  54: ['14', 'D20'],
  53: ['13', 'D20'],
  52: ['12', 'D20'],
  51: ['11', 'D20'],
  50: ['10', 'D20'],
  49: ['9', 'D20'],
  48: ['16', 'D16'],
  47: ['15', 'D16'],
  46: ['14', 'D16'],
  45: ['13', 'D16'],
  44: ['12', 'D16'],
  43: ['11', 'D16'],
  42: ['10', 'D16'],
  41: ['9', 'D16'],
  40: ['D20'],
  39: ['7', 'D16'],
  38: ['D19'],
  37: ['5', 'D16'],
  36: ['D18'],
  35: ['3', 'D16'],
  34: ['D17'],
  33: ['1', 'D16'],
  32: ['D16'],
  31: ['15', 'D8'],
  30: ['D15'],
  29: ['13', 'D8'],
  28: ['D14'],
  27: ['11', 'D8'],
  26: ['D13'],
  25: ['9', 'D8'],
  24: ['D12'],
  23: ['7', 'D8'],
  22: ['D11'],
  21: ['5', 'D8'],
  20: ['D10'],
  19: ['3', 'D8'],
  18: ['D9'],
  17: ['1', 'D8'],
  16: ['D8'],
  15: ['7', 'D4'],
  14: ['D7'],
  13: ['5', 'D4'],
  12: ['D6'],
  11: ['3', 'D4'],
  10: ['D5'],
  9: ['1', 'D4'],
  8: ['D4'],
  7: ['3', 'D2'],
  6: ['D3'],
  5: ['1', 'D2'],
  4: ['D2'],
  3: ['1', 'D1'],
  2: ['D1']
};

export type OutMode = 'double' | 'single' | 'master';

interface Target {
  label: string;
  score: number;
  multiplier: 1 | 2 | 3;
}

const NUMBERS = Array.from({ length: 20 }, (_, i) => 20 - i); // 20..1
const SINGLES: Target[] = NUMBERS.map(n => ({ label: String(n), score: n, multiplier: 1 }));
const DOUBLES: Target[] = NUMBERS.map(n => ({ label: `D${n}`, score: n * 2, multiplier: 2 }));
const TREBLES: Target[] = NUMBERS.map(n => ({ label: `T${n}`, score: n * 3, multiplier: 3 }));
const OUTER_BULL: Target = { label: '25', score: 25, multiplier: 1 };
const BULL: Target = { label: 'Bull', score: 50, multiplier: 2 };
const ALL_TARGETS: Target[] = [...TREBLES, ...SINGLES, ...DOUBLES, OUTER_BULL, BULL];

// Favoriete dubbels: hoe hoger in de lijst, hoe liever (D16 en D20 splitsen goed bij een misser).
const DOUBLE_PREFERENCE = ['D20', 'D16', 'D8', 'D18', 'D12', 'D10', 'D4', 'D14', 'D6', 'D2', 'Bull', 'D19', 'D17', 'D15', 'D13', 'D11', 'D9', 'D7', 'D5', 'D3', 'D1'];
// Voorkeur voor de darts vóór de uitgooi: zware triples en grote enkele vakken; bull is lastig.
const SETUP_PREFERENCE = ['T20', 'T19', 'T18', 'T17', 'T16', 'T15', 'T14', 'T13', 'T12', 'T11', 'T10', ...NUMBERS.map(String)];

function finishCost(t: Target, outMode: OutMode): number | null {
  const isDouble = t.multiplier === 2;
  if (outMode === 'double' && !isDouble) return null;
  if (outMode === 'master' && t.multiplier === 1) return null;
  if (isDouble) {
    const rank = DOUBLE_PREFERENCE.indexOf(t.label);
    return rank === -1 ? 30 : rank;
  }
  // master: triple als uitgooi; enkel uit: elk vak (enkel het makkelijkst)
  return t.multiplier === 3 ? 12 : t.label === '25' ? 15 : 5;
}

function setupCost(t: Target): number {
  const rank = SETUP_PREFERENCE.indexOf(t.label);
  if (rank !== -1) return rank;
  return t.label === '25' || t.label === 'Bull' ? 40 : 35; // dubbels als tussenstap zijn riskant
}

/** Beste route om `score` uit te gooien met maximaal `dartsLeft` darts, met zo min mogelijk darts. */
function solveFinish(score: number, outMode: OutMode, dartsLeft: number): string[] | null {
  const finishers = ALL_TARGETS.filter(t => finishCost(t, outMode) !== null);
  let best: { route: Target[]; cost: number } | null = null;
  const consider = (route: Target[]) => {
    const last = route[route.length - 1];
    const cost = finishCost(last, outMode)! + route.slice(0, -1).reduce((acc, t) => acc + setupCost(t), 0);
    if (!best || cost < best.cost) best = { route, cost };
  };

  for (let darts = 1; darts <= dartsLeft && !best; darts++) {
    for (const last of finishers) {
      const rest = score - last.score;
      if (darts === 1) {
        if (rest === 0) consider([last]);
        continue;
      }
      for (const first of ALL_TARGETS) {
        if (darts === 2) {
          if (rest - first.score === 0) consider([first, last]);
          continue;
        }
        for (const second of ALL_TARGETS) {
          if (rest - first.score - second.score === 0) consider([first, second, last]);
        }
      }
    }
  }
  return best ? (best as { route: Target[] }).route.map(t => t.label) : null;
}

/** Hoe goed is deze restscore voor de volgende beurt? Hoger is beter; 0 = slecht. */
export function leaveQuality(leave: number, outMode: OutMode): number {
  if (leave <= 1) return outMode === 'single' && leave === 1 ? 6 : 0;
  if (outMode === 'single') return leave <= 20 || leave === 25 || leave === 50 ? 6 : 1;
  const double = leave === 50 ? 'Bull' : leave <= 40 && leave % 2 === 0 ? `D${leave / 2}` : null;
  // Dubbels in groepjes van drie: D20/D16/D8 zijn even fijn, daarna D18/D12/D10, enz.
  if (double) return 20 - Math.floor(DOUBLE_PREFERENCE.indexOf(double) / 3) * 2;
  if (outMode === 'master' && leave <= 60 && leave % 3 === 0) return 8;
  // Geen één-dart-uitgooi, maar wel uit te gooien in één beurt
  return leave <= 170 ? 1 : 0;
}

/** Klaarzetten: met alle resterende darts naar een fijne rest voor de volgende beurt. */
function solveSetup(score: number, outMode: OutMode, dartsLeft: number): { darts: string[]; leave: number } | null {
  // Alleen enkele vakken en triples: veilig en gangbaar.
  const options = [...TREBLES, ...SINGLES, OUTER_BULL];
  let best: { darts: Target[]; leave: number; value: number } | null = null;
  const consider = (darts: Target[]) => {
    const leave = score - darts.reduce((acc, t) => acc + t.score, 0);
    const quality = leaveQuality(leave, outMode);
    if (quality === 0) return;
    // Hogere rest-kwaliteit telt het zwaarst; daarna liever minder triples (minder risico) en vaste routes.
    // Een triple mis je vaak: dat weegt ongeveer even zwaar als een iets minder fijne dubbel.
    const risk = darts.reduce((acc, t) => acc + (t.multiplier === 3 ? 25 : 0) + setupCost(t) / 100, 0);
    const value = quality * 10 - risk;
    if (!best || value > best.value) best = { darts, leave, value };
  };
  const recurse = (chosen: Target[]) => {
    if (chosen.length === dartsLeft) return consider(chosen);
    for (const t of options) recurse([...chosen, t]);
  };
  recurse([]);
  return best ? { darts: (best as { darts: Target[] }).darts.map(t => t.label), leave: (best as { leave: number }).leave } : null;
}

export type CheckoutAdvice =
  | { kind: 'finish'; darts: string[] }
  | { kind: 'setup'; darts: string[]; leave: number };

const cache = new Map<string, CheckoutAdvice | null>();

/**
 * Advies voor de speler aan de beurt: een uitgooi-route als die met de resterende darts kan,
 * anders een route om een goede dubbel klaar te zetten. Geeft null als er niets zinnigs te adviseren is
 * (bijvoorbeeld nog ver van de uitgooi).
 */
export function adviseCheckout(score: number, outMode: OutMode, dartsLeft = 3): CheckoutAdvice | null {
  if (score < 1 || dartsLeft < 1) return null;
  const key = `${score}|${outMode}|${dartsLeft}`;
  if (cache.has(key)) return cache.get(key)!;

  let advice: CheckoutAdvice | null = null;
  const table = outMode === 'double' && dartsLeft === 3 ? CHECKOUT_MAP[score] : undefined;
  const finish = table ?? (score <= 180 ? solveFinish(score, outMode, dartsLeft) : null);
  if (finish) {
    advice = { kind: 'finish', darts: finish };
  } else if (score <= 170 || score <= dartsLeft * 60 + 50) {
    // Dichtbij maar niet uit te gooien deze beurt (bogey-getal, te weinig darts): klaarzetten.
    const setup = solveSetup(score, outMode, dartsLeft);
    if (setup) advice = { kind: 'setup', ...setup };
  }

  cache.set(key, advice);
  return advice;
}

/** Oude aanroep: alleen een uitgooi-route (geen klaarzetten). */
export function getCheckoutSuggestion(score: number, outMode: OutMode = 'double', dartsLeft = 3): string[] | null {
  const advice = adviseCheckout(score, outMode, dartsLeft);
  return advice?.kind === 'finish' ? advice.darts : null;
}
